<template>
  <FaqForm />
</template>

<script>
import FaqForm from '@/layouts/components/form/FaqForm.vue'

export default {
  components: { FaqForm },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
